import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const SyncSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 8px;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const Description = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const ModalSubtitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding-top: 24px;
`;

export const ModalList = styled.ul`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 0 24px 24px;
  margin: 0;
`;
